module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/wins-strikeouts-1-b0586ef93e75e51012dce65b26f6f384.svg";